type TEventData = {
  event: string
  eventCategory?: string
  eventAction?: string
  eventLabel?: string
  pageLabel?: string
  eventNonInteraction?: string
  hitTimestamp?: number
  inRegister?: boolean
  pageUrl?: string
}

type TWindowWithDataLayer = Window & {
  dataLayer: Record<string, unknown>[]
}

declare const window: TWindowWithDataLayer

const sendDataLayer = ({ inRegister, ...data }: TEventData) => {
  const { dataLayer } = window

  if (dataLayer === undefined) {
    /* eslint-disable no-console */
    console.warn('[GOOGLE ANALYTICS] - window.datalayer está undefined e deveria ter um valor.')
    return
  }

  const extraData = {
    ssoId: sessionStorage.getItem('sso_id'),
    sellerId: inRegister ? 'em-cadastro' : sessionStorage.getItem('maas-tenantId'),
    service: sessionStorage.getItem('service'),
  }

  dataLayer.push({ ...data, ...extraData })
}

export const sendClickEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel: string,
  extraProps?: Record<string, unknown>,
  pageLabel?: string
) => {
  const data = {
    event: 'clickEvent',
    eventCategory,
    eventAction,
    eventLabel,
    pageLabel,
    eventNonInteraction: '0',
    hitTimestamp: Date.now(),
    ...extraProps,
  }

  sendDataLayer(data)
}

export const sendPageViewEvent = (pageUrl: string, extraProps?: Record<string, unknown>) => {
  const data = {
    event: 'virtualPageview',
    pageUrl,
    ...extraProps,
  }

  sendDataLayer(data)
}

export const sendSelectContent = (
  content_type: string,
  content_id: string,
  extraProps?: Record<string, unknown>,
  pageLabel?: string
) => {
  const data = {
    event: 'select_content',
    content_type,
    content_id,
    pageLabel,
    hitTimestamp: Date.now(),
    ...extraProps,
  }

  sendDataLayer(data)
}
